import * as Profile from "@/components/auth/Profile";
import { ListItem } from "@/components/list/ListItem";
import { teamPageUrl } from "@/urls";
import { twMerge } from "@/utils/twMerge";

import type { TeamShort } from "@/api";

export const TeamListItem = ({
  team,
  rightController,
  size = "default",
  isLink,
  onClick,
  label,
  invertedHoverColor,
  namePostfix,
}: {
  team: TeamShort;
  rightController?: React.ReactNode;
  isLink?: boolean;
  size?: "default" | "sm" | "lg";
  onClick?: () => void;
  label?: string;
  invertedHoverColor?: boolean;
  namePostfix?: string;
}) => {
  const { title, permalink, avatarUrls } = team;

  const content = (
    <>
      <Profile.Userpic name={title || ""} src={avatarUrls?.[64]} />
      <div
        className={twMerge("flex flex-1 flex-col w-full ml-1.5", "leading-[1.2] tracking-tight")}
      >
        <div>
          <div
            className={twMerge(
              "flex-1 truncate -mt-0.75 text-[16px] font-semibold",
              size === "sm" && "-mt-0.5 text-[15px]",
              "sm:text-[17px]",
            )}
          >
            {title} <span className="font-normal text-gray-500">{namePostfix}</span>
          </div>
          <div className={twMerge("text-gray-500 text-[14px]", size === "sm" && "text-[13px]")}>
            @{permalink}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <ListItem
      href={isLink ? teamPageUrl({ teamPermalink: permalink }) : undefined}
      onClick={onClick}
      size={size}
      label={label}
      invertedHoverColor={invertedHoverColor}
      content={content}
      rightController={rightController}
    />
  );
};
